<template>
  <Treeselect
    :multiple="multiple"
    :options="mappedOptions"
    :value="valueIds"
    :placeholder="computedPlaceholder"
    :searchable="searchable"
    :clearable="false"
    @input="onInput"
    value-consists-of="ALL_WITH_INDETERMINATE"
    sortValueBy="INDEX"
  >
    <template #value-label="{ node }">
      <div
        class="chip-label"
        :class="{
          parent: !node.raw.parentId,
          child: node.raw.parentId,
        }"
      >
        {{ node.label }}
      </div>
    </template>
  </Treeselect>
</template>

<script>
import Treeselect from "@riophae/vue-treeselect";
import { isEmpty } from "@/utils/lodash";

export default {
  name: "TreeselectEntity",

  components: { Treeselect },

  props: {
    value: {
      required: true,
    },

    entities: {
      type: Array,
      required: true,
    },

    label: {
      type: String,
      default: "value",
    },

    trackBy: {
      type: String,
      default: "id",
    },

    multiple: {
      type: Boolean,
      default: false,
    },

    placeholder: {
      type: String,
      default: null,
    },

    searchable: {
      type: Boolean,
      default: true,
    },

    isUpdatable: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    computedPlaceholder() {
      return this.value && this.value.length > 0 ? "" : this.placeholder;
    },

    mappedOptions() {
      const entities = this.entities.map((entity) => ({
        ...entity,
        label: entity.value,
      }));

      const map = new Map();

      entities.forEach((entity) => {
        map.set(entity.id, { ...entity });
      });

      const result = [];

      entities.forEach((entity) => {
        if (entity.parentId) {
          const parent = map.get(entity.parentId);

          if (parent) {
            if (!parent.children) {
              parent.children = [];
            }
            parent.children.push(map.get(entity.id));
          }
        } else {
          result.push(map.get(entity.id));
        }
      });

      return result.sort((a, b) => {
        if (a.label === "Без отрасли") return 1;
        if (b.label === "Без отрасли") return -1;
        return 0;
      });
    },

    valueIds() {
      if (!Array.isArray(this.value)) return [];

      return this.value.map((v) => v[this.trackBy]);
    },
  },

  methods: {
    onInput(ids) {
      const result = this.entities.filter((e) => ids.includes(e[this.trackBy]));

      this.$emit("onChange", result);
    },
  },

  created() {
    if (this.isUpdatable || isEmpty(this.entities)) {
      this.$emit("onLoad");
    }
  },
};
</script>

<style lang="less">
@import "~@riophae/vue-treeselect/dist/vue-treeselect.css";
@import "../../assets/less/variables.less";

.vue-treeselect--focused {
  .vue-treeselect__control {
    border-color: rgb(207, 216, 221) !important;
    outline: none !important;
    box-shadow: none !important;
  }
}
.vue-treeselect__control {
  min-height: 44px;
  border: 2px solid rgb(207, 216, 221);
  border-radius: 4px;
  padding: 2px 8px;
}
.vue-treeselect__control:hover {
  border-color: rgb(207, 216, 221) !important;
  box-shadow: none;
}
.vue-treeselect__placeholder {
  color: rgb(121, 145, 156);
  font-family: Roboto, sans-serif;
  font-size: 14px;
}
.vue-treeselect__control-arrow {
  fill: black !important;
  transition: all 0.2s ease;
}
.vue-treeselect__multi-value-item-container {
  padding-top: 2px;
  max-width: 100%;
  .vue-treeselect__multi-value-item {
    background: rgb(221, 227, 230);
    border-radius: 12px;
    font-family: Roboto, sans-serif;
    font-size: 12px;
    color: rgb(38, 50, 57);
    min-height: 24px;
    max-height: 24px;
    padding-right: 4px;
    display: flex;
    justify-content: center;
    align-items: center;
    max-width: 100%;
    span {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    .vue-treeselect__value-remove {
      border: none;
      min-width: 14px;
      min-height: 14px;
      max-width: 14px;
      max-height: 14px;
      padding: 0;
      border-radius: 100%;
      background-color: rgb(121, 145, 156);
      display: flex;
      align-items: center;
      justify-content: center;
      svg {
        fill: rgb(221, 227, 230);
      }
    }
    .chip-label {
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
  }
  .vue-treeselect__multi-value-item:has(.parent) {
    background-color: rgb(121, 145, 156);
    .vue-treeselect__value-remove {
      background-color: rgb(221, 227, 230);
      svg {
        fill: rgb(121, 145, 156);
      }
    }
  }
}
.vue-treeselect__menu {
  font-family: Roboto, sans-serif;
  font-size: 15px;
  border: 2px solid rgb(207, 216, 221);
  border-top: 1px solid rgb(232, 232, 232);
  border-bottom: none;
  margin-bottom: 0px !important;
  background-color: white;
  min-width: 205%;
  max-height: 497px !important;
  padding: 0;
  @media (max-width: 1439px) {
    max-height: 332px !important;
  }
  @media (max-width: 767px) {
    max-height: 231px !important;
  }
  &::-webkit-scrollbar {
    border-radius: @br;
    width: 8px;
    background-color: #ffffff;
  }
  &::-webkit-scrollbar-thumb {
    border-radius: @br;
    width: 8px;
    background-color: fade(#000000, 24%);
    &:hover {
      background-color: fade(#000000, 30%);
    }
  }
  .vue-treeselect__list {
    .vue-treeselect__list-item {
      margin-top: 1px;
      margin-bottom: 1px;
      .vue-treeselect__option {
        height: 32px;
        display: flex;
        align-items: center;
      }
      .vue-treeselect__list {
        position: relative;
        &:before {
          content: "";
          position: absolute;
          top: 0;
          left: 34px;
          width: 1px;
          height: calc(100% - 20px);
          background-color: #cfd8dd;
          z-index: 999;
        }
        .vue-treeselect__option {
          position: relative;
          &:before {
            content: "";
            position: absolute;
            left: 34px;
            top: 11px;
            width: 8px;
            height: 6px;
            border-left: 1px solid #cfd8dd;
            border-bottom: 1px solid #cfd8dd;
            border-radius: 0 0 0 5px;
          }
        }
      }
      .vue-treeselect__checkbox {
        border-color: #7d919b;
        height: 18px;
        width: 18px;
        border-radius: 4px;
        border-width: 2px;
        display: flex;
        justify-content: center;
        align-items: center;
        .vue-treeselect__check-mark,
        .vue-treeselect__minus-mark {
          top: 2px;
          left: 2px;
          background-size: 10px 10px;
          height: 10px;
          width: 10px;
        }
      }
      .vue-treeselect__checkbox--checked,
      .vue-treeselect__checkbox--indeterminate {
        background-color: #7d919b;
      }
    }
  }
}
.vue-treeselect--open-below {
  .vue-treeselect__menu {
    border: 2px solid rgb(207, 216, 221);
    border-radius: 4px;
  }
}
</style>
